var React = require('react');

function AircraftDivderLine (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_1299","data-name":"Group 1299","transform":"translate(0 -88)"},React.createElement("g",{"id":"Component_125_4","data-name":"Component 125 – 4","transform":"translate(0 88)"},[React.createElement("path",{"id":"Path_1427","data-name":"Path 1427","d":"M0,0H86l20,12H0Z","fill":"#f44336","key":0}),React.createElement("rect",{"id":"Image_9","data-name":"Image 9","width":"790","height":"1","transform":"translate(0 11)","fill":"#f44336","key":1})])));
}

AircraftDivderLine.defaultProps = {"width":"100%","viewBox":"0 0 790 12"};

module.exports = AircraftDivderLine;

AircraftDivderLine.default = AircraftDivderLine;
